import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField
} from "@material-ui/core";
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CloseIcon from '@material-ui/icons/Close';
import CreateIcon from '@material-ui/icons/Create';
import DeleteIcon from '@material-ui/icons/Delete';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Alert from '@material-ui/lab/Alert';
import 'rc-tooltip/assets/bootstrap.css';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { deleteSupplyDetailAsync, GetPurchaseOrderDetailRequestAsync, GetSolPurchaseOrderDetailAsync, getSupplyDetailAsync, SetSupplyDetailAsync } from "../../actions/userActions";
import { SubNavBarComponent } from '../../components/layouts/layout1/subnavbar/SubNavBarComponent';
import './sass/styles.scss';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

export const ShoppingRequestDetails = (props) => {

  const requestH = useSelector((state) => state.user.request);
  const loginData = useSelector((state) => state.user.user.identity)

  const solicitud = props.location.state.solicitud;
  const orden = props.location.state.state

  const classes = useStyles();
  const [rowShopping, setRowrowShopping] = useState([])
  const [title, setTitle] = useState('')
  const [idCompra, setIdCompra] = useState('')

  const getPurchaseOrderDetailRequest = async () => {
    if (orden) {
      setTitle('ORDEN DE COMPRA')
      setIdCompra(orden.id)
      await GetPurchaseOrderDetailRequestAsync(orden.id, requestH).then((resp) => {
        setRowrowShopping(resp.response)
      })
    } else if (solicitud) {
      setTitle('SOLICITUD DE COMPRA')
      setIdCompra(solicitud.orderDetailID)
      await GetSolPurchaseOrderDetailAsync(solicitud.orderId, requestH).then((resp) => {
        setRowrowShopping(resp.response)
      })
    }
  }

  useEffect(() => {
    getPurchaseOrderDetailRequest()
  }, [])

  const solicitudDeCompra = [
    { id: 'pedido', label: '# PEDIDO', width: '5%' },
    { id: 'id', label: 'ID', width: '5%' },
    { id: 'productos', label: 'PRODUCTOS', width: '5%' },
    { id: 'cantidad', label: 'CANTIDAD', width: '5%' },

  ];

  const ordenDeCompras = [
    { id: 'solicitud', label: 'ORDEN', width: '5%' },
    { id: 'proveedor', label: 'PROVEEDOR', width: '5%', },
    { id: 'fecha', label: 'FECHA O.C', width: '5%' },
    { id: 'pedido', label: '# PEDIDO', width: '5%' },
    { id: 'id', label: 'PROD ID', width: '5%' },
    { id: 'productos', label: 'PRODUCTOS', width: '5%' },
    { id: 'cantidad', label: 'CANTIDAD', width: '5%' },
    { id: 'eta', label: 'ETA', width: '5%' },
    { id: 'proceso', label: 'PROCESO', width: '5%' },
    { id: 'icon', label: '', width: '5%' },
  ];

  const columnShoppingOrderProductsModal = [
    { id: 'eta', label: 'ETA', width: '5%' },
    { id: 'cantidad', label: 'Cantidad', width: '5%' },
    { id: 'deleteIcon', label: '', width: '5%' },
    // { id: 'editIcon', label: '', width: '5%' },
    // { id: 'confirmIcon', label: '', width: '5%' },
  ];

  const [rowSelected, setrowSelected] = useState({});
  const [rowSupply, setrowSupply] = useState([]);

  const [openModalShoppingProducts, setOpenModalShoppingProducts] = React.useState(false);
  const [openConfirmMessage, setOpenConfirmMessage] = React.useState(false);

  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [selectedQuantity, setselectedQuantity] = React.useState();
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  function isQuantityAvailable(supplies, purchaseOrderDetailId, maxQuantity, quantityToAdd) {
    const total = supplies
      .filter(item => item.purchaseOrderDetailId == purchaseOrderDetailId)
      .reduce((sum, item) => sum + item.quantitySupply, 0);

    return total + quantityToAdd <= maxQuantity;
  }


  const saveSupplier = async () => {
    const quantityAvailable = isQuantityAvailable(rowSupply, rowSelected.purchaseOrderDetailID, rowSelected.quantityOrder, parseInt(selectedQuantity))
    if (quantityAvailable && (parseInt(selectedQuantity) == rowSelected.quantityOrder || parseInt(selectedQuantity) < rowSelected.quantityOrder)) {
      let data = {
        "id": 0,
        "purchaseOrderDetailId": rowSelected.purchaseOrderDetailID,
        "usuId": loginData.userID,
        "quantitySupply": parseInt(selectedQuantity),
        "dateSupply": selectedDate,
        "statusSupply": 0
      }
      await SetSupplyDetailAsync(data, requestH).then((resp) => {
        getSupplyDetail(resp.response.purchaseOrderDetailId);
        setOpenConfirmMessage(true)
      });

    } else {
      toast.info("La Cantidad es Mayor a la Solicitada", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  const getSupplyDetail = async (param) => {
    await getSupplyDetailAsync(param, requestH).then((resp) => {
      setrowSupply(resp.response)
    })
  }

  const deleteSupplyDetail = async (params) => {
    await deleteSupplyDetailAsync(params, requestH).then((resp) => {
      setOpenConfirmMessage(true)
      setrowSupply(resp.response)
    })
  }

  function formatearFecha(fechaOriginal) {
    var partes = fechaOriginal.split(" ");
    var fechaParte = partes[0];

    var fechaSplit = fechaParte.split("/");
    var mes = fechaSplit[0];
    var dia = fechaSplit[1];
    var anio = fechaSplit[2];

    var fechaFormateada = dia + "/" + mes + "/" + anio;

    return fechaFormateada;
  }

  return (
    <div style={{
      width: '100%',
      paddingTop: '16vh',
      height: '100%'
    }}>
      <SubNavBarComponent searchActive={false} typeSearch={'none'} specificType={'listaPrecios'} historyPage={`/shopping`} title={title} />
      <div >

        {/* TopBar */}
        <div style={{ display: 'flex', background: 'transparent', marginTop: '0vh' }}>
          <div style={{ width: '70%', marginTop: '2rem', justifyContent: 'flex-start', display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '50px', justifyContent: 'flex-start', width: '100%' }}>
              <div style={{ width: '30%' }}>
                <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                  <div style={{ borderRadius: 8, display: 'flex', flexDirection: 'column', background: '#d9d9d9' }}>
                    <div style={{ marginTop: 15, marginLeft: 15 }}>
                      {solicitud ?
                        <p style={{ fontFamily: 'arial', fontSize: '15px' }}># De solicitud de compra</p>
                        :
                        <p style={{ fontFamily: 'arial', fontSize: '15px' }}># Orden de compra</p>
                      }
                    </div>
                    <div style={{ marginBottom: 15, marginLeft: 15 }}>
                      <p style={{ fontFamily: 'arial', fontSize: '20px' }}>{idCompra}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabla Solicitud de Compras - Productos */}
        {solicitud &&
          < div style={{ marginTop: 50, margin: '40px auto 40px auto', width: '90%', position: 'relative' }}>
            <TableContainer className={classes.container} style={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    {solicitudDeCompra && solicitudDeCompra.length > 0 && solicitudDeCompra.map((column) => {
                      const id = column.id
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          <div style={{ display: 'flex' }}>
                            {id == 'select' && <Checkbox checked={false} style={{ color: 'black' }} />}
                            {id != 'select' && id != 'remision' && <ImportExportIcon style={{ color: '#484f59' }} />}
                            {column.label}
                          </div>
                        </TableCell>
                      )
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowShopping && rowShopping.length > 0 && rowShopping.map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                        {solicitudDeCompra && solicitudDeCompra.length > 0 && solicitudDeCompra.map((column) => {
                          const type = row.tipo
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {
                                column.id == 'select' ? <Checkbox checked={false} style={{ color: 'black' }} /> :
                                  column.id == 'pedido' ? row.orderId :
                                    column.id == 'id' ? row.productCode :
                                      column.id == 'productos' ? row.productDescription :
                                        column.id == 'cantidad' ? (row.quantityOrder || row.productCount) :
                                          value
                              }
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        }

        {/* Tabla Orden de Compras - Productos */}
        {orden &&
          < div style={{ marginTop: 50, margin: '40px auto 40px auto', width: '90%', position: 'relative' }}>
            <TableContainer className={classes.container} style={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow>
                    {ordenDeCompras && ordenDeCompras.length > 0 && ordenDeCompras.map((column) => {
                      const id = column.id
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          <div style={{ display: 'flex' }}>
                            {id == 'select' && <Checkbox checked={false} style={{ color: 'black' }} />}
                            {id != 'select' && id != 'remision' && <ImportExportIcon style={{ color: '#484f59' }} />}
                            {column.label}
                          </div>
                        </TableCell>
                      )
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowShopping && rowShopping.length > 0 && rowShopping.map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                        {ordenDeCompras && ordenDeCompras.length > 0 && ordenDeCompras.map((column) => {
                          const type = row.tipo
                          const value = row[column.id];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {
                                column.id == 'select' ? <Checkbox checked={false} style={{ color: 'black' }} /> :
                                  column.id == 'solicitud' ? idCompra :
                                    column.id == 'proveedor' ? row.supplier :
                                      column.id == 'fecha' ? row.purchaseOrderDate :
                                        column.id == 'pedido' ? row.orderId :
                                          column.id == 'id' ? row.productCode :
                                            column.id == 'productos' ? row.productDescription :
                                              column.id == 'cantidad' ? (row.quantityOrder || row.productCount) :
                                                column.id == 'eta' ? formatearFecha(row.eta) :
                                                  column.id == 'proceso' ? <p style={{ fontWeight: 'bold', color: row.status == 1 ? '#EB5500' : row.status == 2 ? '#37A7B9' : row.status == 3 ? '#275300' : '#000' }}>{row.status == 1 ? 'Pendiente' : row.status == 2 ? 'En proceso' : row.status == 3 ? 'Recibido' : ''}</p> :
                                                    column.id == 'icon' && orden ? value == 'eye' ? <VisibilityIcon style={{ color: 'black' }} /> : <CreateIcon style={{ color: 'black' }} onClick={() => { setOpenModalShoppingProducts(true); setrowSelected(row); getSupplyDetail(row.purchaseOrderDetailID); }} /> :
                                                      value
                              }
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        }

        {/* Dialog - ShoppingOrder - PRODUCTS */}
        <Dialog
          open={openModalShoppingProducts}
          onClose={() => { setOpenModalShoppingProducts(false) }}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth='xl'
        >
          <DialogTitle id="form-dialog-title"><div style={{ display: 'flex', marginBottom: 40 }}>
            <p style={{ marginRight: 30, fontWeight: 'bold', fontSize: 25 }}>Tiempos de entrega</p>
          </div></DialogTitle>
          <div style={{ display: 'flex', marginLeft: '100px', marginBottom: '20px', flexDirection: 'column', marginRight: '100px', fontFamily: 'arial' }}>

            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
              <div style={{ width: '24%' }}>
                <p style={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '20px',
                  lineHeight: '17px',
                  color: '#484F59'
                }}>{rowSelected.productCode}</p>
                <p style={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '20px',
                  lineHeight: '17px',
                  color: '#484F59'
                }}>Cantidad: {rowSelected.quantityOrder}</p>
                <p style={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 600,
                  fontSize: '24px',
                  lineHeight: '20px',
                  color: '#000000',
                  marginTop: 5
                }}>{rowSelected.productDescription}</p>
                <small>{rowSelected.quantitySupply}</small>
              </div>
              <TextField
                id="date"
                type="date"
                variant="outlined"
                value={selectedDate}
                onChange={(e) => handleDateChange(e.target.value)}
                style={{ width: '24%' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField id="outlined-basic" label="Cantidad a entregar" value={selectedQuantity} onChange={(e) => setselectedQuantity(e.target.value)} variant="outlined" style={{ width: '24%' }} />
              <button className="btn" style={{ width: '10%', fontFamily: 'arial', fontWeight: 'bold' }} onClick={saveSupplier}>AGREGAR</button>
            </div>
            <Collapse in={openConfirmMessage}>
              <Alert
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOpenConfirmMessage(false);
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                Se han actualizado los cambios con éxito
              </Alert>
            </Collapse>
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 20 }}>
              <div style={{ width: '24%' }}>
                <p style={{
                  fontFamily: 'Roboto',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  fontSize: '14px',
                  lineHeight: '17px',
                  color: '#000000'
                }}>Datos del producto</p>
                <Divider style={{ color: '#000' }} />
              </div>
            </div>

            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', marginTop: 20 }}>

              <TableContainer className={classes.container} style={{ maxHeight: 300 }}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      {columnShoppingOrderProductsModal && columnShoppingOrderProductsModal.length > 0 && columnShoppingOrderProductsModal.map((column) => {
                        const id = column.id
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            <div style={{ display: 'flex' }}>
                              {id == 'select' && <Checkbox checked={false} style={{ color: 'black' }} />}
                              {column.label}
                            </div>
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rowSupply && rowSupply.map((row) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                          {columnShoppingOrderProductsModal && columnShoppingOrderProductsModal.length > 0 && columnShoppingOrderProductsModal.map((column) => {
                            const type = row.tipo
                            const value = row[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {
                                  column.id == 'select' ? <Checkbox checked={false} style={{ color: 'black' }} /> :
                                    column.id == 'eta' ? row.dateSupply.split(' ')[0] :
                                      column.id == 'cantidad' ? row.quantitySupply :
                                        column.id == 'deleteIcon' ? <button onClick={(e) => deleteSupplyDetail(row)}><DeleteIcon style={{ color: '#C70808' }} /></button> :
                                          value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem' }}>

            </div>
          </div>
          <DialogContent style={{ alignSelf: 'end' }}>
            <button className="btn" style={{ width: 220, fontFamily: 'arial', fontWeight: 'bold' }} onClick={() => { setOpenModalShoppingProducts(false); setSelectedDate(''); setselectedQuantity('') }}>Cerrar</button>
          </DialogContent>
          <DialogActions style={{ marginTop: 100 }}>
          </DialogActions>
        </Dialog>

      </div >
    </div >
  );
};
